// extracted by mini-css-extract-plugin
var _1 = "Comments_comments__Kdr3v";
var _2 = "Comments_icon__WOXF7";
export { _1 as "comments", _2 as "icon" }
